module.exports = __webpack_public_path__ + "img/mobile_video.e88d9455.png";